/* unplugin-vue-components disabled */import { render } from "./FloatingImage.vue?vue&type=template&id=61b8e40a&scoped=true"
import script from "./FloatingImage.vue?vue&type=script&lang=js"
export * from "./FloatingImage.vue?vue&type=script&lang=js"

import "./FloatingImage.vue?vue&type=style&index=0&id=61b8e40a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b8e40a"]])

export default __exports__